export const experience = [
    {
        duration : 'Dec, 2020 - Present',
        type: 'work',
        organization : 'Cashfree Payments',
        role: 'Frontend Engineer II',
        team: 'Payouts Team',
        location: 'Bengaluru, IN',
        active: true,
        details: [
            "Worked on migrating the Payout Merchant Dashboard from PHP stack to <strong>React</strong>. It involved developing dozens of screens based on UX designs.",
            "Developed and maintained design library for common components used across variety of products that cashfree has to offer. <strong>Date Filters</strong> , customised <strong>Dropdowns</strong> , <strong>Account Switchers</strong>, <strong>OTP Modals</strong> to name a few.",
            "Developed customised charts on top of <strong>re-charts</strong> library which are being used across analytics screen of merchant dashboard. Designed and Developed <strong>Two factor Authentication flow</strong> for user for individual actions that the user performs on the merchant dashboard.",
        ]
    },
    {
        duration : 'May, 2019 - Dec, 2020',
        type: 'work',
        organization : 'Qubole Softwares',
        role: 'Member Of Technical Staff',
        team: 'ETL/EAM Team',
        location: 'Bengaluru, IN',
        active: false,
        details: [
            "Developed CLI application using <strong>Golang</strong> and Cobra library for ops to determine instance capacity for different tiers of application over <strong>AWS</strong>.",
            "Delivered core features like <strong>Airflow Git Integration</strong>, added support for <strong>Hive ACID</strong> as sink on Qubole's offering on streaming Data.",
            "Delivered <strong>Python</strong> Upgrade project (2.7 -> 3.8) for all the Middleware components single-handedly.",
        ]
    },
    {
        duration: 'May, 2018 - May. 2019',
        type: 'work',
        organization: 'Amadeus Software Labs',
        role: 'Software Engineer',
        team: 'AQA Team',
        location: 'Bengaluru, IN',
        active: false,
        details: [
            "Played a key role in developing and maintaining a platform that pulls data out from the <strong>Jenkins</strong> and was integrated with <strong>JIRA</strong> and supported by over 25 APIs to make the analysis of failures during Regression runs effective and easy.",
            "The Platform has a built-in aggregator which builds you a consolidated report with various <strong>infographic</strong> charts for the Release Management Team which helped higher Management to take business decision out of it."        ]
    },
    {
        duration: 'Dec, 2016 - May, 2018',
        type: 'work',
        organization: 'Wipro Limited',
        role: 'Project Engineer',
        team: 'CLIENT: AVIVA',
        location: 'Bengaluru, IN',
        active: false,
        details: [
            "Developed a Desktop Application using <strong>JavaFX</strong> that serves 35 APIs across various domains. The application had customized analytics system that tracks and measure the application usage such as API performances over time, cycle time reduction due to the services built into the application.",
            "Worked on technologies such as <strong>Java</strong>, <strong>REST</strong>, <strong>C#</strong>, <strong>Jenkins</strong>, <strong>MySQL</strong> server to contribute substantially in making projects successful."        ]
    },
    {
        duration: 'August, 2012 - June, 2016',
        type: 'education',
        organization: 'Amity University Rajasthan',
        role: 'Bachelors in Technology',
        team: 'Computer Science and Engineering',
        location: 'Jaipur, IN',
        active: false,
        details: [
            "Secured <strong>8.41</strong> CGPA.",
            "Availed <strong>merit scholarship</strong> for all the 4 years."]
    },
    {
        duration: 'Apr, 2010 - Mar, 2012',
        type: 'education',
        organization: 'Agrasen DAV Public School',
        role: 'CBSE',
        team: 'XII',
        location: 'Ramgarh, IN',
        active: false,
        details: [
            "Secured <strong>87%</strong> in the board exam.",
            "Was school's second topper."]
    },
    {
        duration: 'Apr, 2008 - Mar, 2010',
        type: 'education',
        organization: 'Agrasen DAV Public School',
        role: 'CBSE',
        team: 'X',
        location: 'Ramgarh, IN',
        active: false,
        details: [
            "Secured <strong>9.8 CGPA</strong> in the board exam.",
            "Was school's second topper."]
    }
]